import { render, staticRenderFns } from "./dashboardStats.vue?vue&type=template&id=5ccb0f23&"
import script from "./dashboardStats.vue?vue&type=script&lang=js&"
export * from "./dashboardStats.vue?vue&type=script&lang=js&"
import style0 from "./dashboardStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports